import { render } from "./ConfirmView.vue?vue&type=template&id=130c32b4&scoped=true"
import script from "./ConfirmView.vue?vue&type=script&lang=js"
export * from "./ConfirmView.vue?vue&type=script&lang=js"

import "./ConfirmView.vue?vue&type=style&index=0&id=130c32b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-130c32b4"]])

export default __exports__